// Centralized asset management for MAG Insulation
export const LOGO_URL = "https://storage.googleapis.com/msgsndr/JBn77ZuohKeAb3a76OQk/media/65b1dd2ca716b35726012c58.png";
export const HERO_IMAGE_URL = "https://storage.googleapis.com/msgsndr/JBn77ZuohKeAb3a76OQk/media/69601cdb0597df78cdece558.jpg";
export const APPLICATION_URL = "https://go2.maginsulation.com/widget/survey/bxbI6cAIXwUY8A8Bhesm";
export const CAREERS_EMAIL = "careers@maginsulation.com";